<template>
  <main>
    <router-view />
  </main>
</template>

<script lang="ts" setup>
import { RouterView } from 'vue-router'

import '@sennder/design-system-core/dist/styles/themes/default.css'
import '@sennder/design-system-core'
</script>
